import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllInspecaoPatrimonioUseCase } from "../../../presentation/useCases/read/get_all_inspecao_patrimonio_use_case";
import { InspecaoPatrimonioModel } from "../../models/inspecao_patrimonio";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllInspecaoPatrimonioUseCase
 */

export class GetAllInspecaoPatrimonioUseCase
  extends BasePaginatedUseCase<InspecaoPatrimonioModel>
  implements IGetAllInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllInspecaoPatrimonio(
    idPatrimonioMaquinaEquip: number,
    status: number | null,
    dataDe?: Date | null,
    dataAte?: Date | null,

    page?: number,
    rowsPerPage?: number,
  ): Promise<void> {
    const response = await this.repository.getAllInspecaoPatrimonio(
      idPatrimonioMaquinaEquip,
      status,
      dataDe,
      dataAte,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
